import React, {useState} from 'react';

import apis from "services";
import {useSnackbar} from "notistack";
import {SET_PAGE_NUMBER} from "redux/types";
import {useDispatch, useSelector} from "react-redux";
import {useMutation, useQueryClient} from "react-query";
import {useHistory, useLocation} from 'react-router-dom'
import {selectAllMessages, setVariable} from "redux/actions"
import ToolbarButton from "components/Toolbar/ToolbarButton"
import RecordsPerPage from "components/Toolbar/RecordsPerPage";
import {CustomDialog, MemberDialog, NewMessageDialog} from "components";
//Material UI Components
import {
    AppBar,
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    Grid,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
//Material UI Icons
import {makeStyles} from "@material-ui/styles";
import InboxIcon from '@material-ui/icons/Inbox';
import DeleteIcon from '@material-ui/icons/Delete';
import ArchiveIcon from '@material-ui/icons/Archive';
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutlineSharp';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import FilterButton from "./FilterButton";
import EventEmitter from "reactjs-eventemitter";

const useStyles = makeStyles(() => ({
    positionSticky: {
        top: '3em',
        borderBottom: '1px solid lightgray'
    }
}))

const Index = () => {
    const theme = useTheme();
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const queryClient = useQueryClient();
    const {enqueueSnackbar} = useSnackbar();

    const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));

    const [memberRecords, setMemberRecords] = useState([]);
    const [confirmDialog, setConfirmDialog] = useState(false);

    const {messages, meta, selected} = useSelector(state => state?.messages);
    const {composeDialog, memberDialog, pageNumber, logAccess, user} = useSelector(state => state?.inbox);

    const {mutate} = useMutation('actions', apis.labelActionsApi, {
        onSuccess: async () => {
            enqueueSnackbar("Action Completed", {variant: "success"});
            dispatch(selectAllMessages([]));
            EventEmitter.emit('refetch-messages');
        }
    });

    const slug = location.pathname.split('/')[1];
    const messageId = location.pathname.split('/')[2];
    const isMessagesPage = slug !== 'message'
    const isAllSelected = messages?.length === selected.length && messages?.length > 0;
    const isMessagesPreviousPageDisabled = (meta?.current_page === 1 || meta?.total === 0);
    const isMessagesNextPageDisabled = (meta?.current_page === meta?.last_page || meta?.total === 0)
    const buttonSizeInSMScreen = matchesSM ? 'small' : 'normal'

    //Handle CheckBox
    const handleSelectAllMsg = () => {
        if (!isAllSelected) {
            const selected = messages.map((message) => message.id);
            dispatch(selectAllMessages(selected));
        } else {
            dispatch(selectAllMessages([]));
        }
    };
    const handleBack = () => history.action === "PUSH" ? history.goBack() : history.push('/');
    const handleDialog = (status) => setConfirmDialog(status);
    const handleReload = async () => {
        if (slug === 'message') await queryClient.invalidateQueries('message')
        else await queryClient.invalidateQueries('messages')
    }
    const handleDeleteFromTrash = async () => {
        if (window.confirm(`Are You Sure want to permanent delete?`)) {
            mutate({ids: selected, type: 'master', slug})
        }
    };
    const handleDeleteFromInbox = async (action) => {
        if (window.confirm(`Are You Sure?`)) {
            mutate({ids: selected, type: action, slug})
        }
    }
    //Message Action Like Read Move to Another Tab
    const handleAction = async (action, option) => {
        if (action === 'message' && window.confirm(`Are You Sure?`)) {
            mutate({ids: [messageId], type: 'trash', slug})
            handleBack();

        } else if (action === 'trash' && slug === 'sent' && logAccess?.includes(user?.member_type)) {
            /*===   Open Master Delete Message Dialog ===*/
            handleDialog(true);
        } else if (action === 'trash' && slug === 'trash') {
            await handleDeleteFromTrash()
        } else if (option === 'master' || option === 'trash') {
            /*===   Send Master Delete Message Request   ===*/
            mutate({ids: selected, type: option, slug})
            handleDialog(false);
        } else {
            await handleDeleteFromInbox(action);
        }
        await handleReload();
    };

    const handlePageNumber = (action = '') => {
        let incrementor = 0;
        if (action === 'next')
            incrementor++;
        else
            incrementor--;

        dispatch(setVariable(SET_PAGE_NUMBER, pageNumber + incrementor))
    };


    /*====================     Handling Conditional Rendering for JSX START    ====================*/
    let spamButton, archiveButton, inboxButton, deleteButton, goBackButton, selectMessagesCheckBox,
        singleMessageDelete;
    spamButton = archiveButton = inboxButton = deleteButton = goBackButton = selectMessagesCheckBox = singleMessageDelete =
        null

    /*====== Various Conditions for Specific Buttons for Rendering  ======*/
    const isMessageSelected = selected.length > 0;
    // const displayReadButton = !(["trash", "sent"].includes(slug))
    const displaySpamButton = !(["spam", "sent", "trash"].includes(slug));
    const displayArchiveButton = !(["archive", "sent", "trash"].includes(slug));
    const displayInboxButton = !(["primary", "verified", "anonymous", "sent", "trash"].includes(slug))

    if (isMessageSelected && isMessagesPage) {
        if (displaySpamButton)
            spamButton = <ToolbarButton title="SPAM" onClick={() => handleAction('spam')} Icon={ErrorOutlineIcon}/>

        if (displayArchiveButton)
            archiveButton = <ToolbarButton title="ARCHIVE" onClick={() => handleAction('archive')} Icon={ArchiveIcon}/>

        if (displayInboxButton)
            inboxButton = <ToolbarButton title="INBOX" onClick={() => handleAction('inbox')} Icon={InboxIcon}/>

        /*if(displayReadButton)
            readButton = <ToolbarButton title="MARK AS UNREAD" onClick={() => handleAction('read')} Icon={MarkUnreadMailboxIcon}/>*/

        deleteButton = <ToolbarButton title="DELETE" onClick={() => handleAction("trash")} Icon={DeleteIcon}/>
    }

    if (isMessagesPage) {
        selectMessagesCheckBox =
            <ToolbarButton title={isAllSelected ? "UNSELECT ALL" : "SELECT ALL"} onClick={handleSelectAllMsg}
                           Icon={isAllSelected ? CheckBoxIcon : CheckBoxOutlineBlankIcon}/>

    } else {
        goBackButton = <ToolbarButton title="Back" onClick={handleBack} Icon={ArrowBackIcon}/>
        singleMessageDelete = <ToolbarButton title="DELETE" onClick={() => handleAction("message")} Icon={DeleteIcon}
        />
    }

    /*====================     Handling Conditional Rendering for JSX END    ====================*/
    return (
        <>
            <AppBar position={'sticky'} classes={{positionSticky: classes.positionSticky}}
                    style={{backgroundColor: '#fafafa'}}>
                <Grid container>
                    <Grid item container justify="space-between">
                        <Grid item>
                            <Grid item container>
                                {/*====== Index Buttons for Messages Page   ======*/}
                                <Grid item> {goBackButton}</Grid>
                                <Grid item>{selectMessagesCheckBox}</Grid>
                                <Grid item><ToolbarButton title="RELOAD" onClick={handleReload} Icon={RotateLeftIcon}/></Grid>
                                <Grid item>{archiveButton}</Grid>
                                <Grid item>{deleteButton}</Grid>
                                <Grid item>{spamButton}</Grid>
                                <Grid item>{inboxButton}</Grid>

                                {/*====== Single Message Delete Button for Message Screen   ======*/}
                                <Grid item>{singleMessageDelete}</Grid>
                            </Grid>
                        </Grid>
                        {isMessagesPage && (
                            <Grid item>
                                <Grid item container alignItems="center">
                                    <Grid item>
                                        <RecordsPerPage meta={meta}/>
                                    </Grid>
                                    <Grid item>
                                        <ToolbarButton
                                            title="PREVIOUS PAGE"
                                            onClick={() => handlePageNumber('previous')}
                                            Icon={ArrowBackIosIcon}
                                            disabled={isMessagesPreviousPageDisabled}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <ToolbarButton
                                            title="NEXT PAGE"
                                            onClick={() => handlePageNumber('next')}
                                            Icon={ArrowForwardIosIcon}
                                            disabled={isMessagesNextPageDisabled}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <FilterButton meta={meta}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </AppBar>
            <CustomDialog title='Confirmation!' dialogStatus={confirmDialog} handleClose={() => handleDialog(false)}>
                <DialogContent>
                    <DialogContentText id="confirm-dialog">
                        Are You Sure want to delete this message! For?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button size={buttonSizeInSMScreen}
                            variant={"contained"}
                            color="primary"
                            onClick={() => handleDialog(false)}
                            autoFocus>
                        Cancel
                    </Button>
                    <Button size={buttonSizeInSMScreen}
                            variant={"outlined"}
                            color="primary"
                            onClick={() => handleAction('', 'master')}
                    >
                        Everyone
                    </Button>
                    <Button size={buttonSizeInSMScreen}
                            variant={"outlined"}
                            color="primary"
                            onClick={() => handleAction('', 'trash')}
                    >
                        me
                    </Button>
                </DialogActions>
            </CustomDialog>
            <NewMessageDialog open={composeDialog} memberRecords={memberRecords} setMemberRecords={setMemberRecords}/>
            <MemberDialog open={memberDialog} setMemberRecords={setMemberRecords}/>
        </>
    )
};

export default Index;
